import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    // Newsletter subscription logic would go here
    setSubscribeStatus('success');
    setEmail('');
    setTimeout(() => setSubscribeStatus('idle'), 3000);
  };

  return (
    <footer className="bg-[#f8f8f8] text-[#1a1a2e] border-t border-[#e8e6e3]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Left Area - 40% */}
          <div className="lg:col-span-2">
            <img 
              src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/826c552476badc913a23e7605116bff7.png" 
              alt="MeVER Chair ロゴ" 
              title="MeVER Chair"
              className="h-8 w-auto mb-4"
            />
            <p className="text-sm text-[#4a4a4a] mb-6 leading-relaxed">
              シリコンバレー流の生産性思想から生まれた、<br />
              戦略投資としてのワークチェア。
            </p>
            
            {/* Newsletter Form */}
            <div className="mb-6">
              <div className="text-sm font-medium mb-3 text-[#1a1a2e]">最新情報を受け取る</div>
              <form onSubmit={handleSubscribe} className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="メールアドレス"
                  className="flex-1 px-4 py-2 bg-white border border-[#e8e6e3] rounded-lg text-sm text-[#1a1a2e] placeholder-[#9a9a9a] focus:outline-none focus:border-[#8E7CC3]"
                />
                <button
                  type="submit"
                  className="px-6 py-2 bg-[#8E7CC3] text-white rounded-lg text-sm font-medium hover:bg-[#7A6AAF] transition-colors whitespace-nowrap cursor-pointer"
                >
                  登録
                </button>
              </form>
              {subscribeStatus === 'success' && (
                <p className="text-xs text-[#8E7CC3] mt-2">ご登録ありがとうございます</p>
              )}
            </div>
          </div>

          {/* Right Area - 60% */}
          <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Column 1: Products */}
            <div>
              <h4 className="text-sm font-bold mb-4 text-[#1a1a2e]">製品情報</h4>
              <ul className="space-y-2 text-sm text-[#4a4a4a]">
                <li><a href="#products" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">MeVER Chair Pro</a></li>
                <li><a href="#products" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">MeVER Chair Style</a></li>
                <li><a href="/compare" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">製品比較</a></li>
                <li><a href="#" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">技術仕様</a></li>
              </ul>
            </div>

            {/* Column 2: Support */}
            <div>
              <h4 className="text-sm font-bold mb-4 text-[#1a1a2e]">サポート</h4>
              <ul className="space-y-2 text-sm text-[#4a4a4a]">
                <li><a href="#case-studies" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">導入事例</a></li>
                <li><a href="#roi" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">ROIシミュレーター</a></li>
                <li><a href="#" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">よくある質問</a></li>
                <li><a href="#contact-form" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">お問い合わせ</a></li>
              </ul>
            </div>

            {/* Column 3: Company */}
            <div>
              <h4 className="text-sm font-bold mb-4 text-[#1a1a2e]">企業情報</h4>
              <ul className="space-y-2 text-sm text-[#4a4a4a]">
                <li><a href="/company" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">会社概要</a></li>
                <li><a href="#" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">採用情報</a></li>
                <li><a href="/privacy" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">プライバシーポリシー</a></li>
                <li><a href="/terms" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">利用規約</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#e8e6e3] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-[#9a9a9a]">
          <div className="mb-4 md:mb-0">
            © 2025 MeVER Chair. All rights reserved.
          </div>
          <div className="flex items-center space-x-6">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">
              Powered by Readdy
            </a>
            <a href="#" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">
              <i className="ri-facebook-circle-line text-xl"></i>
            </a>
            <a href="#" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-xl"></i>
            </a>
            <a href="#" className="hover:text-[#8E7CC3] transition-colors cursor-pointer">
              <i className="ri-linkedin-box-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
